import React from 'react';
import {ISlide} from '../../../../incase-domain/slide';
import {MAX_SLIDE_NAME_LENGTH} from '../../../../incase-domain/validators/slide/name';
import {useSlideUpdateContext} from '../../../../ui/context/SetSlideUpdateContext';
import DebouncedTextInput from '../../highlighted/common/debounced/DebouncedTextInput';

interface SlideSettingsHeaderProps {
    slide: ISlide;
}

export default function SlideSettingsHeader(props: SlideSettingsHeaderProps): JSX.Element {
    const {slide} = props;

    const {setSlide} = useSlideUpdateContext();

    const handleUpdateSlideName = (name: string): void => {
        const trimmedName = name.trim();
        if (slide.name !== trimmedName) {
            const updated = {...slide, name: trimmedName};
            setSlide(updated);
        }
    };

    return (
        <>
            <DebouncedTextInput
                value={slide.name}
                onChange={(value) => handleUpdateSlideName(value)}
                className="c-sidepanel__input"
                maxLength={MAX_SLIDE_NAME_LENGTH}
                inlineMaxLength
            />
        </>
    );
}
